import { styles } from '@app/services/app-styles.service';

const toast = {
    // root: {
    //     width: 'calc(100% - ' + styles.pageMargin + ')',
    //     borderWidth: '1.5px',
    // },
    content: {
        padding: styles().paddingSm,
    },
    success: {
        background: styles().layer,
        borderColor: styles().green,
        color: styles().textColor,
    },
    error: {
        background: styles().layer,
        borderColor: styles().warn,
        color: styles().textColor,
    },
    info: {
        background: styles().layer,
        borderColor: styles().primary,
        color: styles().textColor,
    },
};

export default toast;
